import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import 'rxjs/add/operator/do';
import { LoaderService } from '../services/loader.service';
import { EnvService } from '../env-services/env.service';
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    private loaderCount: number = 0;
    constructor(public loaderService: LoaderService, private env: EnvService) {
        this.loaderCount = 0;
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.includes("https://api.ipify.org/")) {
            return next.handle(request);
        }
        
        request = request.clone({ url: this.env.baseUrl + request.url });

        let ShowLoader = true;

        if (ShowLoader) {
            this.loaderCount++;
            if (this.loaderCount > 0) {
                if (document.getElementById("PageLoader") != null)
                    document.getElementById("PageLoader").style.display = 'block';
            }
        }


        return next.handle(request).do((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                if (ShowLoader) {
                    this.loaderCount--;
                    if (this.loaderCount <= 0) {
                        if (document.getElementById("PageLoader") != null) {
                            document.getElementById("PageLoader").style.display = 'none';
                        }
                    }
                }
            }
        }, (err: any) => {
            this.loaderCount--;
            if (this.loaderCount <= 0) {
                if (document.getElementById("PageLoader") != null) {
                    document.getElementById("PageLoader").style.display = 'none';
                }
            }
        });
    }
}

